import { render, staticRenderFns } from "./freewayMaintain.vue?vue&type=template&id=23ebff10&scoped=true"
import script from "./freewayMaintain.vue?vue&type=script&lang=js"
export * from "./freewayMaintain.vue?vue&type=script&lang=js"
import style0 from "./freewayMaintain.vue?vue&type=style&index=0&id=23ebff10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ebff10",
  null
  
)

export default component.exports